<template lang="pug">
b-modal#editMiniGameTemplate(
  ref="editMiniGameTemplate"
  :title="$t('ui.combine.edit_mini_game_template')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$tc('ui.template')").mb-1
      DefaultTemplateLookup(
        ref="template_code"
        size="sm"
        required
        type="array"
        :disabled="loading"
        v-model.trim.lazy="template_code"
        disabled
      )
    b-form-group(:label="$t('ui.status')").mb-1
      label.custom-switch
        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="is_enable")
        span.custom-switch-indicator

    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import config from "@/config";
import DefaultTemplateLookup from "@/library/DefaultTemplateLookup";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    DefaultTemplateLookup
  },
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      template_code: '',
      is_enable: true,
    };
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      let url = config.editMiniGameTemplateUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        game_id: this.item.game_id,
        template_code: this.template_code,
        enable: this.is_enable
      };

      this.feedback.success = true;
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "combine.edit_mini_game_template", this.feedback.status);
              }
              this.$nextTick(() => {
                this.$refs.editMiniGameTemplate.hide();
              });
            }
          } catch (error) {
            this.loading = false;
            if (error.status.toLowerCase() == "nochanges") {
              this.$emit("clicked");
              this.$nextTick(() => {
                this.$refs.editMiniGameTemplate.hide();
              });
            } else {
              this.feedback.success = false;
              this.feedback.status = error.status;
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = response.data.status;
          this.$helpers.handleFeedback(this.feedback.status);
        }
      );
    },
    reset() {
      this.template_code = "";
      this.is_enable = true;
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.template_code = this.item.template_code;
      this.is_enable = this.item.status;
    }
  }
};
</script>
